"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PASSWORD_SCORE_TO_STRENGTH = exports.CONFIGS = void 0;
var _Theme = require("../../../records/Theme");
// Maps the result of zxcvbn to a relative strength
const PASSWORD_SCORE_TO_STRENGTH = exports.PASSWORD_SCORE_TO_STRENGTH = {
  "0": "WEAK",
  "1": "WEAK",
  "2": "MEDIUM",
  "3": "MEDIUM",
  "4": "STRONG"
};
// Different configurations for each one of the password strengths
const CONFIGS = exports.CONFIGS = {
  WEAK: {
    label: "WEAK",
    orbitTextType: "critical",
    color: _Theme.themeDefault.orbit.textCriticalForeground,
    width: "30%"
  },
  MEDIUM: {
    label: "MEDIUM",
    orbitTextType: "warning",
    color: _Theme.themeDefault.orbit.textWarningForeground,
    width: "60%"
  },
  STRONG: {
    label: "STRONG",
    orbitTextType: "success",
    color: _Theme.themeDefault.orbit.textSuccessForeground,
    width: "100%"
  }
};